import { Observable } from 'rxjs';

import { Contact } from 'contact/contact';
import { ContactSort } from 'contact/model/contact.sort';

export abstract class ContactRepositoryPort {
	public abstract saveAll(contacts: Contact[]): void;

	public abstract observeContact(id: string): Observable<Contact>;

	public abstract deleteContact(id: string): Promise<void>;

	public abstract observeContacts(contactsId: string[]): Observable<Contact[]>;

	public abstract observeUserContacts(userId: string): Observable<Contact[]>;

	public abstract observeKanbanContacts(
		ownerId: string,
		kanbanOrgModuleId: string
	): Observable<Contact[]>;
}
